<template>
  <div>
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewEducationRecords" v-if="edited == true" >Descartar cambios</b-button>
    <b-table v-if="educationRecords.length>0" :fields="educationRecordFields" :items="educationRecords" :stacked="'md'" hover striped></b-table>
    <b-button variant="link" v-if="state=='show' && can('update', 'employees') && !deleted" @click="create">Agregar entrada</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Institución">  
        <b-form-input type="text" @input="updateEducationRecord(['institute', $event])" :value="institute"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Título">  
        <b-form-input type="text" @input="updateEducationRecord(['major', $event])" :value="major"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Año">  
        <b-form-input type="number" @input="updateEducationRecord(['year', $event])" :value="year"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Promedio">  
        <b-form-input type="number" @input="updateEducationRecord(['score', $event])" :value="score"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Fecha de inicio">  
        <b-form-input type="date" @input="updateEducationRecord(['start_date', $event])" :value="start_date"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Fecha de finalización">  
        <b-form-input type="date" @input="updateEducationRecord(['end_date', $event])" :value="end_date"></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  data (){
    return {
      educationRecordFields: [
        {
            key:'institute',
            label: 'Institución',
        },
        {
            key: 'major',
            label: 'Título',
        },
        {
            key: 'score',
            label: 'Promedio',
        },
        {
            key: 'year',
            label: 'Año',
        },
        {
            key: 'starting_date',
            label: 'Fecha de inicio',
        },
        {
            key: 'end_date',
            label: 'Fecha de finalización',
        }
      ]
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },

    ...mapActions(['resetNewEducationRecords', 'saveChanges']),
    ...mapMutations({
      updateEducationRecordAttribute: 'updateNewEducationRecordAttribute',
      create: 'creatingEducationRecord'
    }),
    addIfValid (){
      var validation = this.valid()
      if(validation.valid)
        this.$store.dispatch('addEducationRecord');
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.major!='', 'Debe poner el título del registro')
      validator.rule(
        this.institute!='', 'Debe poner la institución que otorgó el título')

      if (this.start_date !== '' && this.end_date !== '') {
        var startDate = new Date(this.start_date);
        var endDate = new Date(this.end_date);
        validator.rule(
          endDate.getTime() > startDate.getTime(), 'La fecha de finalización debe ser mayor a la fecha de inicio.'
        );
      }

      return validator.validate()
    },
    updateEducationRecord([attribute, value]) {
      this.updateEducationRecordAttribute([attribute, value]);
    }
  },
  computed: {
    ...mapGetters({
      edited: 'educationRecordEdited'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      educationRecords: state=>state.employeeManager.employee.educationRecords,
      state: state=>state.employeeManager.educationRecordState,
      year: state=>state.employeeManager.newEducationRecord.year,
      score: state=>state.employeeManager.newEducationRecord.score,
      major: state=>state.employeeManager.newEducationRecord.major,
      institute: state=>state.employeeManager.newEducationRecord.institute,
      end_date: state=>state.employeeManager.newEducationRecord.end_date,
      start_date: state=>state.employeeManager.newEducationRecord.start_date,
      deleted_at: state=>state.employeeManager.employee.deleted_at,
    }),
    deleted() {
      return this.deleted_at !== null;
    }
  }
  
}
</script>
